export default __webpack_public_path__ + "static/media/smardroponics_feature_image.121493d8.png";